import React, {useCallback, useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import TripCard from "./partial/TripCard";
import InfiniteScroll from "react-infinite-scroller";
import Fetching from "./fetching";
import axiosConfig from "./utils/axiosConfig";
import SearchForm from "./partial/search-form";

const Finder = ({partner, tripTypes, destinations}) => {
    const [searchParams] = useSearchParams();
    const [search, setSearch] = useState(searchParams.get("s") ?? "");
    const [type, setType] = useState(searchParams.get("reiseart") ?? "");
    const [dest, setDest] = useState(searchParams.get("reiseziel") ?? "");

    const navigate = useNavigate();

    const [trips, setTrips] = useState([]);

    const [nextPage, setNextPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [fetching, setFetching] = useState(false);

    // Function to fetchDestinations using Axios
    const fetchTrips = useCallback(async () => {
        if (fetching) return;

        setFetching(true);
        try {
            const response = await axiosConfig.get(`/agency/${process.env.REACT_APP_AGENCY_NO}/trips?type=${type}&dest=${dest}&search=${search}&page=${nextPage}`);
            setTrips([...trips, ...response.data.data]);

            setNextPage(response.data.current_page + 1)
            setLastPage(response.data.last_page)
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setFetching(false);
        }

    }, [nextPage, lastPage, fetching]);

    const hasMoreItems = nextPage <= lastPage;

    const reloadP = (search, type, dest) => {
        setSearch(search)
        setType(type)
        setDest(dest)
        navigate(`/reisefinder?s=${search}&tour_search=1&reiseart=${type}&reiseziel=${dest}`);
        window.location.reload();
    }

    // Call fetchData on component mount
    useEffect(() => {
        document.title = `${partner?.name} - Reisefinder`;
    }, []);
    return (
        <div className="archive travel_tour travel_tour-page">
            <div className="site wrapper-content">
                <div className="top_site_main" style={{backgroundColor: '#fff'}}>
                </div>
                <section className="content-area">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="widget-area col-md-3 col-sm-12 position-relative">
                                <SearchForm tripTypes={tripTypes} destinations={destinations} showBadge={true}
                                            action={`${process.env.PUBLIC_URL}/reisefinder/`}>

                                </SearchForm>
                            </div>
                            <div className="site-main col-md-9 col-sm-12">
                                <InfiniteScroll
                                    pageStart={nextPage}
                                    loadMore={fetchTrips}
                                    hasMore={hasMoreItems}
                                    loader={<Fetching isFetching={true}></Fetching>}
                                >
                                    <ul className="tours products wrapper-tours-slider">
                                        {trips.length > 0 ? (trips.map((post) => (
                                            <TripCard trip={post} cnt={3}></TripCard>
                                        ))) : (
                                            <h1 className="text-center">Keine Reisen gefunden</h1>
                                        )}
                                    </ul>
                                </InfiniteScroll>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Finder;